<script>
export default {
  props: {
    tag: { type: String, default: 'span' },
    template: { type: String, default: '' },
  },
  data: () => ({
    regex: /\$[0-9]/g,
  }),
  computed: {
    templateKeys() {
      return this.template.match(this.regex) || [];
    },
    templateStatic() {
      return this.template.split(this.regex);
    },
    renderArray() {
      return this.templateStatic.reduce((acc, item, index) => {
        acc.push(item);
        acc.push(this.$slots[this.templateKeys[index]]);
        return acc;
      }, []);
    },
  },
  render(h) {
    return h(this.tag, this.renderArray);
  },
};
</script>
